import Sdk from '@/sdk';

export default {
    namespaced: true,
    state: {
        list: [],
        total: 0,
    },
    getters: {},
    actions: {
        async fetch({ state }, {
            page, type, filter, query, sort, desc,
        }) {
            const limit = 10;
            const params = {
                offset: (page - 1) * limit,
                limit,
                filter: { type, ...filter },
                search: query,
                sort: {},
            };

            if (sort) {
                params.sort[sort] = desc;
            }
            const result = await Sdk.News.PrivateList({ params });
            state.list = result.data.raw;
            state.total = result.data.total;
        },
        preProcessForm(__, data) {
            if (!data.cover) {
                // eslint-disable-next-line no-param-reassign
                data.cover = '';
            }
            return new Sdk.FormData(data, [{
                urls: [data.cover],
                ext: (mimetype) => ({
                    'image/png': 'png',
                    'image/jpeg': 'jpg',
                }[mimetype] || 'png'),
            }]);
        },
        async create({ dispatch }, data) {
            const form = await dispatch('preProcessForm', data);
            return Sdk.News.PrivateCreateResource(form);
        },
        async update({ dispatch }, data) {
            const { id, ...payload } = data;
            const form = await dispatch('preProcessForm', payload);
            return Sdk.News.PrivateUpdateResource(id, form);
        },
        delete(__, data) {
            return Sdk.News.PrivateDeleteResource(data.id);
        },
    },
};
